// extracted by mini-css-extract-plugin
export default {"checkbox":"Select_checkbox__+sdHz","checked":"Select_checked__7Yzm6"};